import styled from "styled-components";

export const SRegisterFormTitle = styled.h1`
  font-family: Inter;
  font-size: 40px;
  font-weight: 700;
  line-height: 52px;
  letter-spacing: -0.03em;
  text-align: center;

  color: var(--text-01);
`;
